import { useQuery } from "@tanstack/react-query"
import { campaignsImpactQuery } from "../lib/campaignsImpactQuery"

export function useCampaignsImpactQuery(...args: Parameters<typeof campaignsImpactQuery>) {
  return useQuery(campaignsImpactQuery(...args))
}
